<template>
    <div class="duxiu">
        <!-- <p></p> -->
        <div class="imgDiv">
            <img src="../../assets/duxiu/img/dxlogo.png" alt="" />
        </div>
        <div class="duxiu_top">
            <van-field v-model="book" label="书名：" placeholder="请输入书名" />
            <van-field v-model="author" label="作者：" placeholder="请输入作者" />
            <van-field v-model="word" label="主题词：" placeholder="请输入主题词" />
            <van-field v-model="publish" label="主题词出版社：" placeholder="请输入主题词出版社" />
            <van-field v-model="isbn" label="ISBN：" placeholder="请输入ISBN" />
            <van-field v-model="cnfenlei" label="分类号：" placeholder="请输入分类号" />
            <div style="background: #fff;line-height:46px">
                <div class="label">
                    <span>发表时间</span>
                </div>
                <van-field
                    readonly
                    clickable
                    :value="yearStart"
                    placeholder="开始时间"
                    @click="year1 = true"
                    style="width:31%;float:left;padding-left:6px;"
                />
                <van-popup v-model="year1" position="bottom">
                    <van-picker show-toolbar :columns="columnsStaet" @confirm="staetConfirm" @cancel="year1 = false" />
                </van-popup>
                <span style="float:left;">至</span>
                <van-field readonly clickable :value="yearEnd" placeholder="结束时间" @click="year2 = true" style="width:31%;float:left" />
                <van-popup v-model="year2" position="bottom">
                    <van-picker show-toolbar :columns="columnsEnd" @confirm="endConfirm" @cancel="year2 = false" />
                </van-popup>
            </div>
            <div>
                <van-field readonly clickable label="分类" :value="flValue" @click="flShowPicker = true" />
                <van-popup v-model="flShowPicker" position="bottom">
                    <van-picker show-toolbar :columns="flColumns" @cancel="flShowPicker = false" @confirm="flOnConfirm" />
                </van-popup>
            </div>
        </div>
        <van-button type="info" @click="retrieval()">检索</van-button>
    </div>
</template>
<script>
// import { Toast } from 'vant'
export default {
    data() {
        return {
            book: "",
            author: "",
            word: "",
            publish: "",
            isbn: "",
            cnfenlei: "",
            yearStart: "",
            yearEnd: "",
            year1: false,
            year2: false,
            columnsStaet: [],
            columnsEnd: [],
            flValue: "全部分类",
            flShowPicker: false,
            flColumns: [
                "全部分类",
                "马克思主义、列宁主义、毛泽东思想、邓小平理论",
                "哲学、宗教",
                "社会科学总论",
                "政治、法律",
                "军事",
                "经济",
                "文化、科学、教育、体育",
                "语言、文字",
                "文学",
                "艺术",
                "历史、地理",
                "自然科学总论",
                "数理科学和化学",
                "天文学、地球科学",
                "生物科学",
                "医药、卫生",
                "农业科学",
                "工业技术",
                "交通运输",
                "航空、航天",
                "环境科学、安全科学",
                "综合性图书"
            ]
        };
    },
    mounted() {
        this.$store.dispatch("actionsHead", { type: true, title: "读秀学术搜索", iconType: false });
        for (let i = 0; i < 25; i++) {
            this.columnsStaet.push(new Date().getFullYear() - i);
            this.columnsEnd.push(new Date().getFullYear() - i);
        }
    },
    methods: {
        flOnConfirm(value) {
            this.flValue = value;
            this.flShowPicker = false;
        },
        staetConfirm(value) {
            this.yearStart = value;
            this.year1 = false;
            var arr = [];
            for (let i = 0; i < this.columnsEnd.length; i++) {
                if (this.columnsEnd[i] >= value) {
                    arr.push(this.columnsEnd[i]);
                }
            }
            this.columnsEnd = arr;
        },
        endConfirm(value) {
            this.year2 = false;
            this.yearEnd = value;
            var arr = [];
            for (let i = 0; i < this.columnsStaet.length; i++) {
                if (this.columnsStaet[i] <= value) {
                    arr.push(this.columnsStaet[i]);
                }
            }
            this.columnsStaet = arr;
        },
        retrieval() {
            var data = new Object();
            if (this.book != "") {
                data.book = this.book;
            }
            if (this.author != "") {
                data.author = this.author;
            }
            if (this.word != "") {
                data.word = this.word;
            }
            if (this.publish != "") {
                data.publish = this.publish;
            }
            if (this.isbn != "") {
                data.isbn = this.isbn;
            }
            if (this.cnfenlei != "") {
                data.cnfenlei = this.cnfenlei;
            }
            if (this.yearStart != "") {
                data.yearStart = this.yearStart;
            }
            if (this.yearEnd != "") {
                data.yearEnd = this.yearEnd;
            }
            data.page = 1;
            data.bstype = 1;
            // ['全部分类', '马克思主义、列宁主义、毛泽东思想、邓小平理论', '哲学、宗教', '社会科学总论', '政治、法律', '军事', '经济', '文化、科学、教育、体育', '语言、文字', '文学', '艺术', '历史、地理', '自然科学总论', '数理科学和化学', '天文学、地球科学', '生物科学', '医药、卫生', '农业科学', '工业技术', '交通运输', '航空、航天', '环境科学、安全科学', '综合性图书']
            switch (this.flValue) {
                case "全部分类":
                    data.fenleiid = "";
                    break;
                case "马克思主义、列宁主义、毛泽东思想、邓小平理论":
                    data.fenleiid = "01";
                    break;
                case "哲学、宗教":
                    data.fenleiid = "02";
                    break;
                case "社会科学总论":
                    data.fenleiid = "03";
                    break;
                case "政治、法律":
                    data.fenleiid = "04";
                    break;
                case "军事":
                    data.fenleiid = "05";
                    break;
                case "经济":
                    data.fenleiid = "06";
                    break;
                case "语言、文字":
                    data.fenleiid = "07";
                    break;
                case "文化、科学、教育、体育":
                    data.fenleiid = "08";
                    break;
                case "文学":
                    data.fenleiid = "09";
                    break;
                case "艺术":
                    data.fenleiid = "10";
                    break;
                case "历史、地理":
                    data.fenleiid = "11";
                    break;
                case "自然科学总论":
                    data.fenleiid = "12";
                    break;
                case "数理科学和化学":
                    data.fenleiid = "13";
                    break;
                case "天文学、地球科学":
                    data.fenleiid = "14";
                    break;
                case "生物科学":
                    data.fenleiid = "15";
                    break;
                case "医药、卫生":
                    data.fenleiid = "16";
                    break;
                case "农业科学":
                    data.fenleiid = "17";
                    break;
                case "工业技术":
                    data.fenleiid = "18";
                    break;
                case "交通运输":
                    data.fenleiid = "19";
                    break;
                case "航空、航天":
                    data.fenleiid = "20";
                    break;
                case "环境科学、安全科学":
                    data.fenleiid = "21";
                    break;
                case "综合性图书":
                    data.fenleiid = "22";
                    break;
            }

            this.$router.push({
                path: "/duxiuList",
                query: data
            });
        }
    }
};
</script>
<style lang="less">
.duxiu {
    background: #fff;
    .imgDiv {
        background: #fff;
        border-bottom: 1px solid #e3e3e3;
        text-align: center;
        margin-top: 0.8rem;
        img {
            width: 40%;
            margin: 1rem 0;
        }
    }
    > div {
        overflow: hidden;
    }
    span {
        font-size: 14px;
    }
    .label {
        float: left;
        font-size: 14px;
        padding-left: 16px;
        width: 30%;
        // span {
        //     padding: 0 0 0 0.5rem;
        // }
    }
    .van-cell--clickable {
        .van-field__control {
            background: url("../../publics/image/07.png") 95% center no-repeat;
            border: 1px solid #dadada;
            padding: 0 0.5rem;
            border-radius: 2px;
        }
    }
    .van-cell__title {
        width: 30%;
        // span {
        //     padding: 0 0 0 0.5rem;
        // }
    }
    .van-field__control {
        border-bottom: 1px solid #e3e3e3;
        border-radius: 0;
        width: 97%;
    }
    > button {
        width: 81%;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 2rem;
        background: #3f7eff;
        border: 0.05333rem solid #3f7eff;
    }
}
</style>
